import { render, staticRenderFns } from "./renew.vue?vue&type=template&id=20c7d96a&scoped=true&"
import script from "./renew.vue?vue&type=script&lang=js&"
export * from "./renew.vue?vue&type=script&lang=js&"
import style0 from "./renew.vue?vue&type=style&index=0&id=20c7d96a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c7d96a",
  null
  
)

export default component.exports